import { FBT } from "@/lib/i18n/i18n_provider";
import { getTime } from "@/offering/time_utils";

/**
 *@param startTime `1000` for 10am
 *@param endTime `1630` for 4:30pm
 *@returns `6.5`
 */
export function getDuration(startTime: string, endTime: string) {
  const [startHours, startMinutes] = getTime(startTime);
  const [endHours, endMinutes] = getTime(endTime);
  const hourDuration = endHours - startHours;
  const minuteDuration = (endMinutes - startMinutes) / 60;
  const duration = hourDuration + minuteDuration;

  return Math.round(duration * 100) / 100;
}

export function toDurationString(duration: number, fbt: FBT) {
  const hours = Math.floor(duration);
  const minutes = Math.round((duration - hours) * 60);

  const hoursString =
    hours === 1
      ? fbt("1 hr")
      : hours > 1
      ? fbt(fbt.param("numberOfHours", hours) + " hrs")
      : undefined;
  const minutesString =
    minutes > 0
      ? fbt(fbt.param("numberOfMinutes", minutes) + " mins")
      : undefined;

  let durationString = hoursString || "";
  if (minutesString) {
    durationString += ` ${minutesString}`;
  }

  return durationString.trim();
}
